// @flow
import React, { Component } from 'react';

import { withRouter } from 'Client/router/withRouter';

type Props = {
  location: RouterLocation<{}, {}>,
  onChange: (value: *) => *,
  queryKey: string,
};

class _WatchLocationQueryChange extends Component<Props> {
  componentDidMount() {
    const { location, queryKey, onChange } = this.props;

    if (location.queryParams[queryKey]) {
      onChange(location.queryParams[queryKey]);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { location, queryKey, onChange } = this.props;

    if (
      prevProps.location.queryParams[queryKey] !== location.queryParams[queryKey] &&
      prevProps.location.pathname === location.pathname
    ) {
      onChange(location.queryParams[queryKey]);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  render() {
    return null;
  }
}

export const WatchLocationQueryChange = withRouter(_WatchLocationQueryChange);
